module.exports = __webpack_public_path__ + "img/temp2.6c72367d.jpg";